import { Card, CardHeader, Typography, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../app/slices/restTimeSlice";
import RestTimeForm from "../../form";
import { MdChair } from "react-icons/md";

const RestTimeHeader = () => {
  const _RestTime = useSelector((state) => state.restTime.restTime);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            اوقات الاستراحة
          </Typography>
        }
        avatar={<MdChair size={20} />}
        action={
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => dispatch(setDialog())}
          >
            إضافة
          </Button>
        }
      />
      {_RestTime.dialog ? <RestTimeForm /> : null}
    </Card>
  );
};

export default RestTimeHeader;
